import React, { useEffect, useState } from "react";
import {
  getFirestore,
  collection,
  addDoc,
  onSnapshot,
  deleteDoc,
  doc,
  updateDoc
} from "firebase/firestore";
import { FaTrashAlt, FaEdit, FaCheck, FaTimes } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { useUserPermissions } from "../Hooks/GetUserPermissions";

const AccionesPlanificadas = () => {
  const { hubId } = useParams();
  const db = getFirestore();

  const [acciones, setAcciones] = useState([]);
  const [editandoId, setEditandoId] = useState(null);
  const [nuevaAccion, setNuevaAccion] = useState({
    orden: "",
    entidad: "",
    ambito: "",
    accion: "",
    relevancia: "",
    responsable: "",
    fechaInicio: "",
    fechaFin: "",
    finalizada: false
  });
  const { permisos, loading } = useUserPermissions();

  useEffect(() => {
    const unsubscribe = onSnapshot(
      collection(db, "private-hubs", hubId, "AccionesPlanificadas"),
      (snapshot) => {
        const datos = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data()
        }));
        setAcciones(datos);
      },
      (error) => {
        if (error.code === "permission-denied") {
          setAcciones([]); // Limpiar datos cacheados
        } else {
          console.error("Error al escuchar acciones planificadas:", error);
        }
      }
    );
    return () => unsubscribe();
  }, [db, hubId]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNuevaAccion({
      ...nuevaAccion,
      [name]: type === "checkbox" ? checked : value
    });
  };

  const handleAgregar = async (e) => {
    e.preventDefault();
    try {
      await addDoc(
        collection(db, "private-hubs", hubId, "AccionesPlanificadas"),
        nuevaAccion
      );
      setNuevaAccion({
        orden: "",
        entidad: "",
        ambito: "",
        accion: "",
        relevancia: "",
        responsable: "",
        fechaInicio: "",
        fechaFin: "",
        finalizada: false
      });
    } catch (error) {
      console.error("Error al agregar acción:", error);
    }
  };

  const handleEliminar = async (id) => {
    if (
      !window.confirm("¿Seguro que quieres eliminar esta acción planificada?")
    )
      return;
    try {
      await deleteDoc(
        doc(db, "private-hubs", hubId, "AccionesPlanificadas", id)
      );
    } catch (error) {
      console.error("Error eliminando acción:", error);
      alert("No se pudo eliminar la acción.");
    }
  };

  const handleEditar = (accion) => {
    setEditandoId(accion.id);
    setNuevaAccion({ ...accion });
  };

  const handleGuardar = async () => {
    try {
      await updateDoc(
        doc(db, "private-hubs", hubId, "AccionesPlanificadas", editandoId),
        nuevaAccion
      );
      setEditandoId(null);
      setNuevaAccion({
        orden: "",
        entidad: "",
        ambito: "",
        accion: "",
        relevancia: "",
        responsable: "",
        fechaInicio: "",
        fechaFin: "",
        finalizada: false
      });
    } catch (error) {
      console.error("Error al guardar los cambios:", error);
    }
  };

  const handleCancelar = () => {
    setEditandoId(null);
    setNuevaAccion({
      orden: "",
      entidad: "",
      ambito: "",
      accion: "",
      relevancia: "",
      responsable: "",
      fechaInicio: "",
      fechaFin: "",
      finalizada: false
    });
  };

  if (loading) return <div>Cargando...</div>;

  return (
    <div className="data-box calendar-box">
      <h2 className="data-box-title">Próximas acciones planificadas:</h2>

      <form onSubmit={handleAgregar}>
        <table className="data-table no-highlight">
          <thead>
            <tr className="tier1-data">
              <th>Nº</th>
              <th>Entidad</th>
              <th>Ámbito</th>
              <th>Acción</th>
              <th>Relevancia</th>
              <th>Responsable</th>
              <th>Fecha Inicio</th>
              <th>Fecha Fin</th>
              <th>Hecho</th>
              <th>Acciones</th>
            </tr>
          </thead>

          <tbody>
            {acciones
              .sort((a, b) => a.orden - b.orden)
              .map((accion) => (
                <tr key={accion.id} className="accion-row">
                  {editandoId === accion.id ? (
                    <>
                      <td>
                        <input
                          type="number"
                          name="orden"
                          value={nuevaAccion.orden}
                          onChange={handleChange}
                          style={{ width: "6vh" }}
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          name="entidad"
                          value={nuevaAccion.entidad}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          name="ambito"
                          value={nuevaAccion.ambito}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          name="accion"
                          value={nuevaAccion.accion}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          name="relevancia"
                          value={nuevaAccion.relevancia}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          name="responsable"
                          value={nuevaAccion.responsable}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <input
                          type="date"
                          name="fechaInicio"
                          value={nuevaAccion.fechaInicio}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <input
                          type="date"
                          name="fechaFin"
                          value={nuevaAccion.fechaFin}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          name="finalizada"
                          checked={nuevaAccion.finalizada}
                          onChange={handleChange}
                        />
                      </td>
                      {permisos.verAccPlan === "lectura_escritura" && (
                        <td>
                          <button type="button" onClick={handleGuardar}>
                            <FaCheck />
                          </button>
                          <button type="button" onClick={handleCancelar}>
                            <FaTimes />
                          </button>
                        </td>
                      )}
                    </>
                  ) : (
                    <>
                      <td>{accion.orden}</td>
                      <td>{accion.entidad}</td>
                      <td style={{lineHeight: '1.1'}}>{accion.ambito}</td>
                      <td style={{lineHeight: '1.1'}}>{accion.accion}</td>
                      <td>{accion.relevancia}</td>
                      <td>{accion.responsable}</td>
                      <td>{accion.fechaInicio || "-"}</td>
                      <td>{accion.fechaFin || "-"}</td>
                      <td>
                        <input
                          type="checkbox"
                          checked={accion.finalizada}
                          onClick={(e) => e.preventDefault()}
                          readOnly
                        />
                      </td>
                      <td>
                        {permisos.verAccPlan === "lectura_escritura" && (
                          <>
                            <button
                              type="button"
                              onClick={() => handleEditar(accion)}
                              className="btn-editar"
                            >
                              <FaEdit />
                            </button>
                            <button
                              type="button"
                              onClick={() => handleEliminar(accion.id)}
                              className="btn-eliminar"
                            >
                              <FaTrashAlt />
                            </button>
                          </>
                        )}
                      </td>
                    </>
                  )}
                </tr>
              ))}
          </tbody>

          {permisos?.verAccPlan === "lectura_escritura" && (
            <tfoot>
              <tr>
                <td>
                  <input
                    type="number"
                    name="orden"
                    value={nuevaAccion.orden}
                    onChange={handleChange}
                    required
                    max={99}
                    min={1}
                    style={{ width: "100%" }}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    name="entidad"
                    placeholder="Entidad"
                    value={nuevaAccion.entidad}
                    onChange={handleChange}
                    required
                    maxLength={40}
                    style={{ width: "100%" }}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    name="ambito"
                    placeholder="Ámbito"
                    value={nuevaAccion.ambito}
                    onChange={handleChange}
                    required
                    maxLength={25}
                    style={{ width: "100%" }}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    name="accion"
                    placeholder="Acción"
                    value={nuevaAccion.accion}
                    onChange={handleChange}
                    required
                    maxLength={70}
                    style={{ width: "100%" }}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    name="relevancia"
                    placeholder="Relevancia"
                    value={nuevaAccion.relevancia}
                    onChange={handleChange}
                    required
                    maxLength={15}
                    style={{ width: "100%" }}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    name="responsable"
                    placeholder="Responsable"
                    value={nuevaAccion.responsable}
                    onChange={handleChange}
                    required
                    maxLength={15}
                    style={{ width: "100%" }}
                  />
                </td>
                <td>
                  <input
                    type="date"
                    name="fechaInicio"
                    value={nuevaAccion.fechaInicio}
                    onChange={handleChange}
                    style={{ width: "100%" }}
                  />
                </td>
                <td>
                  <input
                    type="date"
                    name="fechaFin"
                    value={nuevaAccion.fechaFin}
                    onChange={handleChange}
                    style={{ width: "100%" }}
                  />
                </td>
                <td></td>
                <td>
                  <button type="submit">Agregar</button>
                </td>
              </tr>
            </tfoot>
          )}
        </table>
      </form>
    </div>
  );
};

export default AccionesPlanificadas;
